import { Component, OnInit, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { ServiceMgmtService } from '../../../../core/services/service-mgmt.service';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../shared/loading/loading.component';

@Component({
  selector: 'app-service-mgmt',
  templateUrl: './service-mgmt.component.html',
  styleUrls: ['./service-mgmt.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgxPaginationModule,
    SampleSearchPipe,
    LoadingComponent
  ]
})
export class ServiceMgmtComponent implements OnInit {

  data: any[] = [];
  selected_data: any = null;
  get activeCount(): number { return this.data.filter(d => d.is_active).length; }
  loading = false;
  loading2 = false;
  search_text = '';
  pg = { pageSize: 10, p: 1, total: 0 };

  constructor(
    private serviceMgmt: ServiceMgmtService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getAll();
  }

  getAll(): void {
    this.loading2 = true;
    this.serviceMgmt.getAll().subscribe(
      (res: any) => {
        this.data = res.data ?? res;
        this.pg.total = this.data.length;
        this.loading2 = false;
      },
      (err: any) => {
        this.loading2 = false;
        AppErrorShow.showError('Services', err);
      }
    );
  }

  select(item: any): void {
    this.selected_data = item;
  }

  show(content: TemplateRef<any>): void {
    if (!this.verify()) return;
    this.modalService.open(content, { size: 'lg', centered: true });
  }

  toggleActive(item: any): void {
    const newState = !item.is_active;
    const label = newState ? 'activer' : 'désactiver';
    AppSweetAlert.confirmBox('question', 'Confirmation', `Voulez-vous ${label} ce service ?`)
      .then((result: any) => {
        if (result.isConfirmed) {
          this.serviceMgmt.setActive(item.id, newState).subscribe(
            (res: any) => {
              item.is_active = newState;
              this.toastr.success(res.message ?? 'Statut mis à jour');
            },
            (err: any) => AppErrorShow.showError('Services', err)
          );
        }
      });
  }

  delete(item?: any): void {
    const target = item ?? this.selected_data;
    if (!target) { this.toastr.warning('Sélectionnez un service'); return; }
    AppSweetAlert.confirmBox('warning', 'Suppression', 'Supprimer définitivement ce service ?')
      .then((result: any) => {
        if (result.isConfirmed) {
          this.serviceMgmt.delete(target.id).subscribe(
            (res: any) => {
              this.toastr.success(res.message ?? 'Service supprimé');
              this.selected_data = null;
              this.getAll();
            },
            (err: any) => AppErrorShow.showError('Services', err)
          );
        }
      });
  }

  verify(): boolean {
    if (!this.selected_data) {
      this.toastr.warning('Aucun service sélectionné');
      return false;
    }
    return true;
  }

  getPage(event: any): void {
    this.pg.p = event;
  }

  formatPrice(price: any): string {
    const n = parseFloat(price);
    return isNaN(n) ? '—' : n.toLocaleString('fr-FR') + ' FCFA/h';
  }
}
